/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import PropTypes from "prop-types";
import { checkS3URL } from "../validators/common.js";
import ReactPlayer from "react-player";
import { getProjectThumbStyle } from "../../assets/helper.js";
import "./RenderProjectHeader.css";

const RenderHeader = (props) => {
  const headerImg = props.headerBackgroundPicture;

  if (!headerImg || headerImg.length <= 1) {
    const headerPictureStyle = getProjectThumbStyle(headerImg);

    return (
      <div
        className="Header-picture"
        style={{
          ...headerPictureStyle,
          ...props.additionalStyle,
        }}
      />
    );
  }

  return (
    <div className="Header-newSlider">
      {headerImg.map((url) => {
        if (checkS3URL(url)) {
          return (
            // image
            <img src={url} alt={url} key={url} className="Header-height" />
          );
        }
        return (
          // youtube
          <ReactPlayer
            className="Header-height"
            width={"100%"}
            height={"auto"}
            url={url}
            key={url}
          />
        );
      })}
    </div>
  );
};

RenderHeader.propTypes = {
  headerBackgroundPicture: PropTypes.array,
  additionalStyle: PropTypes.object,
};

RenderHeader.defaultProps = {
  additionalStyle: {},
};

export default RenderHeader;
